import { createContext, useContext } from "react";

/**
 * Shared with the email template forms while creating a campaign:
 * - `values`: example placeholder values (campaign, product, contract, company) from what's known
 *   so far, shown next to each placeholder
 * - `platformReviewHtml`: the product platform's review template html, which new review templates
 *   start from
 */
const EmailTemplatePreviewContext = createContext({});

export const EmailTemplatePreviewProvider =
  EmailTemplatePreviewContext.Provider;

export const useEmailTemplatePreview = () =>
  useContext(EmailTemplatePreviewContext);
